import { darkGrayFontColor, titles } from '../../../../web/styles/colors';
import { borderColor, brandPrimary, grayDark, white } from '../../../styles/colors';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	card: {
		backgroundColor: white,
		border: `1px solid ${borderColor}`,
		borderRadius: 10,
		overflow: 'hidden',
	},
	cardBody: {
		padding: '16px 20px 20px',
	},
	cardRegularText: {
		color: '#1a1a1a',
		fontSize: 14,
		whiteSpace: 'nowrap',
		width: '100%',
	},
	cardRegularTextTitle: {
		color: grayDark,
		fontSize: 12,
		width: '100%',
	},
	cardTicketStrip: {
		alignItems: 'center',
		backgroundColor: brandPrimary,
		color: white,
		display: 'flex',
		fontSize: 12,
		justifyContent: 'space-between',
		padding: '8px 20px',
	},
	cardTicketLabel: {
		color: white,
		fontWeight: 600,
	},
	cardTicketRight: {
		alignItems: 'center',
		display: 'flex',
		gap: 12,
	},
	cardDescription: {
		color: '#1a1a1a',
		fontSize: 14,
		lineHeight: 1.5,
		marginTop: 4,
		wordBreak: 'break-word',
	},
	checkbox: {
		color: white,
	},
	checkboxComplete: {
		color: 'rgba(255, 255, 255, 0.6)',
	},
	completedInfo: {
		color: 'rgba(255, 255, 255, 0.8)',
		fontSize: 12,
	},
	container: {
		padding: 20,
		paddingBottom: 40,
	},
	contentWrapper: {
		backgroundColor: white,
		borderRadius: 8,
		display: 'flex',
		flexDirection: 'column',
		margin: 'auto',
		maxWidth: 1100,
		padding: 24,
	},
	dateButton: {
		color: darkGrayFontColor,
		flex: 1,
		justifyContent: 'space-between',
		':hover': {
			color: darkGrayFontColor,
		},
	},
	dateButtonActive: {
		color: titles,
		':hover': {
			color: titles,
		},
	},
	dateButtonGroup: {
		width: 'inherit',
	},
	filter: {
		alignItems: 'flex-end',
		display: 'flex',
		flexWrap: 'wrap',
		gap: 16,
		paddingBottom: 20,
	},
	filterGroup: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
	},
	filterLabel: {
		fontSize: 12,
		fontWeight: 600,
	},
	itemCategory: {
		flexShrink: 0,
		width: 180,
	},
	itemCompany: {
		flexShrink: 0,
		width: 150,
	},
	leadLink: {
		color: brandPrimary,
		textDecoration: 'underline',
		':hover': {
			opacity: 0.8,
		},
	},
	itemDescription: {
		flex: 3,
		minWidth: 300,
		whiteSpace: 'normal',
	},
	listItemsContainer: {
		paddingTop: 10,
	},
	loadingSpinner: {
		marginTop: 30,
	},
	emptyState: {
		color: grayDark,
		fontSize: 14,
		padding: '40px 0',
		textAlign: 'center',
	},
	regularText: {
		color: brandPrimary,
	},
});
